import React from "react";
import Card from "components/card";
import Button from "components/button";
import { Popover } from "antd";

const RewardCard = ({
    title = "",
    date = "",
    icon: Icon,
    iconGradient = "",
    popoverContent = "",
}) => {
    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-purple-200 dark:border-purple-900/50 bg-gradient-to-br from-purple-50 to-white">
            <div className="p-6">
                <div className="flex flex-col items-center text-center">
                    <Popover content={popoverContent} trigger="hover" placement="top" overlayClassName="reward-popover">
                        <div className={`w-10 h-10 rounded-full gradient ${iconGradient} shadow-lg border-2 border-white flex items-center justify-center cursor-pointer hover:scale-110 transition-transform`}>
                            {Icon && <Icon className="w-5 h-5 text-white" />}
                        </div>
                    </Popover>
                    <h4 className="font-semibold mt-4">{title} </h4>
                    <p className="text-sm text-slate-700 mt-1">{date}</p>
                    <Button
                        type="button"
                        className="inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all border bg-white hover:bg-slate-100 hover:shadow-none shrink-0 h-8 rounded-lg gap-1.5 px-3 w-full mt-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
                        aria-label="Share Achievement"
                        disabled={false}
                    >
                        Share Achievement
                    </Button>
                </div>
            </div>
        </Card>
    )
};
export default RewardCard;